import { render } from "./AppButton.vue?vue&type=template&id=d79e1798&scoped=true"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"

import "./AppButton.vue?vue&type=style&index=0&id=d79e1798&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d79e1798"

export default script